import { QueryHookOptions } from '@apollo/client';
import React from 'react';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useQuery } from '@ts-gql/apollo';

export const GET_USER_FILTER_LIST_QUERY = gql`
  query GetUserFilterList(
    $includeDeleted: Boolean = false
    $workView: WorkView = null
  ) {
    getUserFilterList(includeDeleted: $includeDeleted, workView: $workView) {
      cloudId
      name
      filterDefinition
      workView
      isDefault
    }
  }
` as import('../../__generated__/ts-gql/GetUserFilterList').type;

export type GetUserFilterListQueryVariables = OperationVariables<
  typeof GET_USER_FILTER_LIST_QUERY
>;
export type GetUserFilterListQueryResult = OperationData<
  typeof GET_USER_FILTER_LIST_QUERY
>;

export type GetUserFilterListResult = NonNullable<
  ReturnType<typeof processData>
>[number];

export const useGetUserFilterList = (
  options?: QueryHookOptions<
    GetUserFilterListQueryResult,
    GetUserFilterListQueryVariables
  >
) => {
  const variables = options?.variables as GetUserFilterListQueryVariables;

  const res = useQuery(GET_USER_FILTER_LIST_QUERY, {
    context: { service: 'users' },
    variables,
    ...options,
  });

  return React.useMemo(
    () => ({
      ...res,
      data: processData(res.data),
    }),
    [res]
  );
};

export function processData(data: GetUserFilterListQueryResult | undefined) {
  const rows = data?.getUserFilterList;
  const results = rows?.map((filter) => ({
    ...filter,
    workView: filter.workView,
  }));

  return results;
}
